import Vue from 'vue'
const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', (e) => {
          if (!el.disabled) {
            el.style.pointerEvents = 'none'
            el.style.cursor = 'not-allowed'
            el.style.opacity = '0.5'
            setTimeout(() => {
              el.style.pointerEvents = 'auto'
              el.style.cursor = ''
              el.style.opacity = '1'
                }, binding.value || 2000)
            } else {
                // disabled为true时，阻止默认的@click事件
                e.preventDefault()
                e.stopPropagation()
            }
        }, true)
    }
});

export {
    preventReClick
}